<li class="list-item btn {{stateClass}}">
  <h3>{{item.name}}</h3>
</li>
